import { createApolloFetch } from 'apollo-fetch'

// runQuery runs a query on 'model', with 'params' specifiying an array of
// shape { name, type, value }, and 'fields' an array of field(s) you want returned
export const runQuery = (model, params, fields, literalFieldString) => {
  const uri = process.env.REACT_APP_GRAPHQL_ROOT
  const apolloFetch = createApolloFetch({ uri })

  // apply middleware
  apolloFetch.use(({ request, options }, next) => {
    if (!options.headers) {
      options.headers = {}  // create the headers object if needed
    }
    // get the authentication token from local storage if it exists
    options.headers['authorization'] = "Token " + localStorage.getItem('token') || null
    next()
  })

  let typesString = params &&
    params.map(param => (
      `$${param.name}: ${param.type}`
    )).toString()

  let paramsString = params &&
    params.map(param => (
      `${param.name}: $${param.name}`
    )).toString()

  let fieldsString = fields === null
    ? literalFieldString
    : fields.length === 0
      ? fields.toString()
      : fields.toString().replace(/,/g , ' ')

  console.log(`Running query for ${model} with ${params && JSON.stringify(params)} fetching fields: ${fieldsString}`)
  const query = `
    query runQuery${params ? `(${typesString})` : ''} {
      ${model}${params ? `(${paramsString})` : ''} {
        ${fieldsString}
      }
    }
  `
  const variables = {}
  if (params) {
    for (let param of params) {
      variables[param.name] = param.value
    }
  }
  return apolloFetch({ query, variables })
    .then(result => {
      if (result.error) {
        console.log("Running of query failed", result.error)
      } else {
        console.log("Query ran succesfully")
        return result
      }
    })
    .catch(error => {
      console.log("Something went wrong attempting to run query", error)
    })
}

export const runQueryWithVariables = (query, variables) => {
  const uri = process.env.REACT_APP_GRAPHQL_ROOT
  const apolloFetch = createApolloFetch({ uri })

  // apply middleware
  apolloFetch.use(({ request, options }, next) => {
    if (!options.headers) {
      options.headers = {}  // create the headers object if needed
    }
    // get the authentication token from local storage if it exists
    options.headers['authorization'] = "Token " + localStorage.getItem('token') || null
    next()
  })

  return apolloFetch({ query, variables })
    .then(result => result)
}



// WEBPACK FOOTER //
// ./src/utils/query/index.js